import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { BRAND } from "@/lib/content";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin/dashboard");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back, Komel");
      navigate("/admin/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 radial-glow" />
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="relative glass rounded-3xl p-10 w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <span className="inline-flex items-center justify-center rounded-full bg-white/95 p-1">
            <img src={BRAND.favicon} alt="ENRICH VASTU" className="h-10 w-10 object-contain rounded-full" />
          </span>
          <span className="font-display text-2xl"><span className="text-gold">ENRICH</span> Admin</span>
        </div>
        <h1 className="font-display text-3xl mb-1">Sign in</h1>
        <p className="text-[#94A3B8] text-sm mb-8">Manage blog, projects, testimonials & gallery.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="bg-white/5 border-white/15 h-12 text-white placeholder:text-[#64748B]" />
          <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="bg-white/5 border-white/15 h-12 text-white placeholder:text-[#64748B]" />
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-primary-green h-12 font-medium text-white transition-colors hover:bg-[#059669] disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <><Lock size={16} /> Sign In</>}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
